import { Observable, BehaviorSubject } from 'rxjs'
import { AngularFireDatabase } from 'angularfire2/database'
import { Utilities } from '../Utilities'

import { NgZone } from '@angular/core'

export class GettingStartedStages {
    constructor(private loggedInUserId:Observable<string>, private shelvableRoot:firebase.database.Reference, private db:AngularFireDatabase) {
        NgZone.assertInAngularZone();
    }

    data:Observable<any> = this.loggedInUserId.flatMap((userId) => {
        NgZone.assertInAngularZone();
        if (userId === null) {
            return Observable.of(null);
        } else {
            var ref = this.shelvableRoot.child('users').child(userId).child('userData').child('gettingStartedStages');
            return this.db.object(ref);
        }
    });

    private async firebaseObj() {
        var userId = await this.loggedInUserId.take(1).toPromise();
        var ref = this.shelvableRoot.child('users').child(userId).child('userData').child('gettingStartedStages');
        return this.db.object(ref);
    }

    async maybeProgress(from:string, to:string):Promise<void> {
        console.log(`maybe progressing from stage ${from} to ${to}`);
        var data = await this.data.take(1).toPromise();
        if (data && !data.$exists()) return;

        if (data[from]) {
            var update = {};
            update[from] = false;
            update[to] = true;
            await (await this.firebaseObj()).update(update);
        }
    }

    async finish():Promise<void> {
        var data = await this.data.take(1).toPromise();
        if (data && !data.$exists()) return;

        for (var stage in data) {
            //todo
            if (!stage.startsWith('$') && stage !== 'forEach') {
                data[stage] = false;
            }
        }
        await (await this.firebaseObj()).update(data);
    }

    async begin():Promise<void> {
        this.finish();
        
        (await this.firebaseObj()).update({
            newShelf: true
        });
    }
}


// WEBPACK FOOTER //
// ./web/static/services/ShelvableBackend/GettingStartedStages.ts